var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents3" }, [
    _c("img", { staticClass: "bg", attrs: { src: _vm.bgImg } }),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contents" }, [
      _c("p", { staticClass: "text1" }, [
        _vm._v("\n      센터 이동 및 대기시간"),
        _c("br"),
        _vm._v("\n      2~3시간 NO!"),
        _c("br"),
        _vm._v("\n      카수리 평균 서비스 시간 40분!"),
        _c("br")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text2" }, [
        _vm._v("\n      집 또는 사무실 등 원하는 장소와 날짜에"),
        _c("br"),
        _vm._v("\n      전문 정비사가 직접 찾아가 교체해 드립니다."),
        _c("br")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-341925d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-341925d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/main/Contents3.vue
// module id = null
// module chunks = 